import { render } from "./AddMetamask.vue?vue&type=template&id=10f6dfe6&scoped=true"
import script from "./AddMetamask.vue?vue&type=script&lang=js"
export * from "./AddMetamask.vue?vue&type=script&lang=js"

import "@/Common/Styles/connectionAndPolygonModal.scss?vue&type=style&index=0&id=10f6dfe6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f6dfe6"]])

export default __exports__